import { render } from "./AAboutUs.vue?vue&type=template&id=59bb5144&scoped=true"
import script from "./AAboutUs.vue?vue&type=script&lang=js"
export * from "./AAboutUs.vue?vue&type=script&lang=js"

import "./AAboutUs.vue?vue&type=style&index=0&id=59bb5144&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59bb5144"]])

export default __exports__